import { Button } from "@mui/material";

interface ViewUXCamSessionsButtonProps {
  workerId: string;
}

export function ViewUXCamSessionsButton(props: ViewUXCamSessionsButtonProps) {
  const { workerId } = props;

  const url = `https://app.uxcam.com/app/5d56404b3596b9296940b28a/sessions/list/1?user_custom_property=%7B%22o%22%3A%22in%22%2C%22pn%22%3A%22user_id%22%2C%22pv%22%3A%5B%22${workerId}%22%5D%2C%22tb%22%3A%22appuser%22%7D`;

  return (
    <Button variant="outlined" onClick={() => window.open(url, "_blank", "noopener,noreferrer")}>
      View UXCam sessions
    </Button>
  );
}
